package com.anjuros.website.templates.template4.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.shared.AnjurosBackgroundImage
import com.anjuros.website.templates.template4.components.Template4SectionTitle
import com.anjuros.website.templates.template4.components.Template4TestimonialCard
import com.anjuros.website.templates.template4.modules.Template4Review
import com.anjuros.website.templates.template4.modules.Template4Section
import com.anjuros.website.templates.template4.styles.Template4SmallSectionWidthStyle
import com.anjuros.website.templates.template4.util.Template4Constants
import com.anjuros.website.templates.template4.util.Template4Res
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px

@Composable
fun Template4TestimonialSection(){
    Box(
        modifier = Modifier
            .id(Template4Section.Testimonial.id)
            .fillMaxSize()
            .padding(bottom = 100.px),
        contentAlignment = Alignment.Center
    ) {

        AnjurosBackgroundImage(
            src = Template4Res.Image.template4_testimonial_background,
            alt = "Best websites for sole traders in the UK",
            modifier = Modifier.fillMaxSize()
        )
        Column(
            modifier = Modifier.fillMaxSize()
            ,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Template4SectionTitle(
                modifier = Template4SmallSectionWidthStyle.toModifier()
                    .margin(bottom = 75.px),
                section = Template4Section.Testimonial,
                alignment = Alignment.CenterHorizontally
            )
            SimpleGrid(
                numColumns = numColumns(base = 1, md = 2, lg = 3),
                modifier = Modifier.fillMaxSize()
            ) {

                Template4Review.entries.forEach { template4Review ->
                    Template4TestimonialCard(template4Review)

                }
            }

        }


    }
}